export default "__VITE_ASSET__60f452d2__"